module.exports = __webpack_public_path__ + "images/b8f2a20eab01db632d0a50eb7cf53e8f.jpg";